import { makeAutoObservable } from 'mobx';
import { isMobile } from 'react-device-detect';
import { roomModelControllerStore } from '../roomModelController/roomModelController.store';
import { unityfooterStore } from '../unityfooter/unityfooter.store';
import { sendMessageStore } from '../../modules/unityLayout/sendMessage.store';
import {
  NftDataType,
  TCallData,
  TPlayerUserData,
  TPortalData,
  UnityLayout,
} from '../../modules/unityLayout/unityLayout.type';
import { participantsStore } from '../participents/participants.store';
import { globalStore } from '../../global.store';
import { agoraStore } from '../../modules/scenetemplate/stores/agora.store';
import { scenetemplateStore } from '../../modules/scenetemplate/stores/scenetemplate.store';
import { cacheService } from '../../services/cacheService';
import {
  shopEcommerceStore,
  TShopItem,
} from '../ShopEcommerce/shopEcommerce.store';
import { popokGameStore } from '../PopokGame/community.store';
import { pdfStore } from '../pdfIframe/pdf.store';
import { apiServiceDepartments, apiServiceV2 } from '../../services/apiService';
import {
  build,
  CallStatus,
  keyReactManager,
  MICROPHONE_STATUS,
  reactManagerOptions,
} from '../../modules/scenetemplate/hooks/constants';
import { customSort } from '../../helpers/utils';
import {
  checkEventIsEnded,
  checkEventsDates,
  isVisitor,
} from '../../helpers/isVisitor';
import { isAdmin, isCreator } from '../../helpers/isAdminOrCreator';
import { ticketupload } from '../TicketUpload/ticketupload.store';
import { privateTalkStore } from '../../modules/scenetemplate/stores/privateTalk.store';
import { reserveTablePopupsStore } from '../reserveTablePopups/reserveTablePopups.store';
import { transformUserData } from './helpers/transformData';
import { cardsblockStore } from '../cardsblock/cardsblock.store';
import { requestOptions } from '../../helpers/getCurrentApi';
import { HotelRoom } from '../../types/global.types';
import realEstateStore from './Stores/realEstate.store';
import { getKickTimeEnd } from './Controllers/room';

export type keyFunction = keyof typeof UnityProviderStore;

export type TRoomData = {
  logo: string;
  name: string;
  creator: {
    id: number;
    username: string;
    email: string;
  };
};

const {
  privateCallHandler,
  inviteHandler,
  responseCallUser,
  leavePrivateCall,
} = privateTalkStore;


class UnityProviderStore {
  instance: any = null;

  isLoaded = false;

  controllersProps: any;

  locked = false;

  isActiveControllers = false;

  portalData: TPortalData | null;

  roomData: any = {};

  micPermission = false;

  showFaq = false;

  blockedUsers: any = [];

  roomDataStatus = false;

  hooryToken = '';

  roomId: string;

  searchValue = '';

  avatarPosition: any;

  roomUsersState: UnityLayout.RoomUsersState[] = [];

  filteredUsers: UnityLayout.RoomUsersState[] = [];

  unityLoaded = false;

  hideView = false;

  loadingProgression = 0;

  updateTexture: Function;

  openUrl = '';

  nftData: NftDataType;

  build: any = {};

  loader = '';

  copiaData: any = null;

  hotelRooms: HotelRoom[] = [];

  bannerUrl: any = null;

  bannerData: any = {};

  showBookingPopup = false;

  conferencePopup = false;

  managerOptions: any = {};

  constructor() {
    makeAutoObservable(this);
  }

  get showAvatarModeSwitcher() {
    return !this.roomData?.isShowAvatar;
  }

  get getMyOptions() {
    const res = this.roomUsersState.filter(
      (user) => user.publicId == cacheService.getMyId,
    )[0];
    return { ...res, isCreator: this.isMyRoom };
  }

  get renderRoomUsers() {
    if (this.searchValue) {
      return this.filteredUsers;
    }
    return this.roomUsersState;
  }

  get isMyRoom() {
    const res = this.roomData?.creator?.id == cacheService.getMyId;
    return res;
  }

  setIsLoaded = (state: boolean) => {
    this.isLoaded = state;
  };

  setManagerOptions = (type: keyReactManager, id: string) => {
    const manager: keyReactManager =
      type === 'room'
        ? cardsblockStore.withoutAvatar
          ? 'zoom'
          : 'room'
        : type;
    this.roomId = id;
    this.managerOptions = reactManagerOptions[manager];
  };

  setShowBookingPopup = (state: boolean) => {
    this.showBookingPopup = state;
  };

  callHandler = (eventName: keyFunction, ...args: any[]) => {
    const handler = this[eventName as keyof UnityProviderStore];
    if (typeof handler === 'function') {
      handler.call(this, ...args);
    } else {
      console.warn(`Handler ${eventName} does not exist on UnityProviderStore`);
    }
  };

  dispatchReactUnityEvent = this.callHandler;

  setLoadingProgression = (num: number) => {
    this.loadingProgression = Math.floor(num * 100);
  };

  setRoomName = (name: string) => {
    this.roomData = {
      ...this.roomData,
      name,
    };
  };

  onLikeRoom = async (roomId: string | undefined) => {
    const res = await apiServiceV2.handleLikeRoom(Number(roomId));
    if (!res.error) {
      this.roomData = {
        ...this.roomData,
        isLiked: res.data.isLiked === 1,
        likesTotalCount:
          this.roomData.likesTotalCount + (res.data.isLiked === 1 ? 1 : -1),
      };
    } else {
      globalStore.setToasts(true, 'something_went_wrong');
    }
  };

  setBlockHooryClicks(bool: boolean) {
    // this.blockHooryClicks = bool
  }

  onLoaderUnitLoaded = (e: any) => {
    this.setLoadingProgression(e);
  };

  onOpenProgressChanged = (e: any) => {
    this.setLoadingProgression(e);
  };

  onKickOffUser = (userId: number, roomId: number, message: string) => {
    if (userId === Number(cacheService.get('Id'))) {
      const time = message.split('kicked for ')[1];
      const hours = time.endsWith('hours') ? time.split(' hours')[0] : 0;
      const minutes = time.endsWith('minutes') ? time.split(' minutes')[0] : 0;
      const data = {
        hours,
        minutes,
      };
      globalStore.setNotifications(
        true,
        'start_kicked',
        'You have been kicked for',
        data,
      );
      this.setIsLoaded(false);
      this.roomData = {};
      sendMessageStore.sendMessage('ReactManager', 'UnloadSpace', `${roomId}`);
      globalStore.navigation('/dashboard/cerebrum');
    }
  };

  setInstance = (instance: any) => {
    this.instance = instance;
  };

  setBannerUrl = (data: any) => {
    this.bannerUrl = data;
  };

  setOpenUrl = (str: any) => {
    this.openUrl = str;
  };

  onOpenRaffle = (...data: any) => {
    console.log(data);
  };

  onSceneLoaded = (...data: any) => {
    console.log('onSceneLoaded', data);
  };

  onGuestOpenRaffle = (...data: any) => {
    console.log(data);
  };

  onOpenBannerSaleNft = (...data: any) => {
    console.log(data);
  };

  onOpenCerebrumNft = (...data: any) => {
    console.log(data);
  };

  // onUserJoined = (username: string) => {
  //     if (username === globalStore.userData.username) {
  //         sendMessageStore.sendMessage("ReactManager", "UnloadSpace", `${cacheService.getRoomId}`);
  //         // globalStore.logout()
  //         cacheService.clear();
  //         logoutPopupStore.setShowLogoutPopup(false)
  //         globalStore.userData = null;
  //         globalStore.isLogin = false
  //         globalStore.navigation("/dashboard/cerebrum")
  //         globalStore.setNotifications(true, 'duble_login');
  //     }
  // };

  onMicrophoneUseAbilityChanged = (id: number, state: number) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === id) {
        participantsStore.user.micPermissions = state;
        user.micPermissions = state;
      }
      return user;
    });
  };

  onVoucherCopied = (...data: any) => {
    console.log(data);
  };

  onVigogoExploreExpired = (...data: any) => {
    console.log(data);
  };

  onMicrophonePermissionChanged = (id: number, state: number) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === id) {
        participantsStore.user.micPermissionGranted = state;
        user.micPermissionGranted = state;
      }
      return user;
    });
  };

  onLeaveFromGame = (...data: any) => {
    console.log(data);
  };

  onHideView = (...data: any) => {
    this.setIsLoaded(true);
    this.hideView = true;
  };

  onUserAdminRollChanged = (publicId: number) => {
    const condidate = participantsStore.adminUsers.filter(
      (user: any) => user.id == publicId,
    )[0];
    if (!condidate) {
      const curUser = this.roomUsersState.filter(
        (user: any) => user.publicId == publicId,
      )[0];
      participantsStore.setAdminUsers([
        ...participantsStore.adminUsers,
        {
          username: curUser.username,
          id: curUser.publicId,
        },
      ]);
      if (cacheService.getMyId === publicId) {
        globalStore.setNotifications(true, 'admin');
      }
    } else {
      participantsStore.adminUsers = participantsStore.adminUsers.filter(
        (user: any) => user.id != publicId,
      );
      if (cacheService.getMyId === publicId) {
        globalStore.setNotifications(true, 'remove_admin');
      }
    }
    unityProviderStore.roomUsersState.map((user: any) => ({
      ...user,
      isAdmin: !!condidate,
    }));
  };

  searchHandler = (val: string) => {
    this.searchValue = val;
    if (val.length) {
      const filteredUsers = [...customSort(this.roomUsersState, val)];
      this.filteredUsers = filteredUsers;
    } else {
      this.filteredUsers = [];
    }
  };

  onSceneUnLoaded = (...data: any) => {
    console.log(data);
  };

  setLocked = (bool: boolean) => {
    this.locked = bool;
  };

  onReturnCurrentUsersIds = (...data: any) => {
    console.log(data);
  };

  onAgoraIndividualInviteAnswer = (...data: any) => {};

  onFullScreenShare = (...data: any) => {
    console.log(data);
  };

  onUserLeaved = (...data: any) => {
    console.log(data, 'Leaved');
  };

  onSelectWheel = (...data: any) => {
    console.log(data);
  };

  onOpenBanner = (data: any) => {
    // const bannerData = JSON.parse(data)
    this.setBannerData({
      url: 'https://www.fastshift.am/en/',
      imgUrl:
        'https://fv-media.storage.googleapis.com/environment_bundle/T-shirt.glb',
    });
  };

  setBannerData = (data: any) => {
    this.bannerData = data;
  };

  onSetAsEnvironment = (...data: any) => {
    console.log(data);
  };

  onUploadNft = (...data: any) => {
    console.log(data);
  };

  onZoomNft = (...data: any) => {
    console.log(data);
    this.nftData = JSON.parse(data[0]);
  };

  onDeleteNft = (...data: any) => {
    console.log(data);
  };

  onOpenBook = (...data: any) => {
    pdfStore.setPdfUrl(data[0]);
  };

  onOpenSlotGame = (url: string) => {
    const token = globalStore.userData.externalToken;
    const gameUrl = `${url}&externalToken=${token}`;
    popokGameStore.setGameUrl(gameUrl);
  };

  onOpenGamblingTable = (data: any) => {
    // console.log(JSON.parse(data));
  };

  onOpenEcommerceProduct = (data: any) => {
    const res: TShopItem = JSON.parse(data);
    shopEcommerceStore.setShopData(res);
    shopEcommerceStore.setShopPopup(true);
  };

  OnOpenHooryForUser = (token: any) => {
    this.setHooryToken(token);
  };

  onOpenHooryWidget = (token: any) => {
    this.setHooryToken(token);
  };

  OnSelectionTransformChange = (...data: any) => {
    console.log(data);
  };

  onCurrentTransformCommandIndexChanged = (step: any) => {
    roomModelControllerStore.setCurrentStep(step);
  };

  onTransformCommandsCountChanged = (step: any) => {
    roomModelControllerStore.setEndStep(step);
  };

  onOpenPortalToSpace = (roomId: number, name: string, image: string) => {
    sendMessageStore.lockKeyboardInput();
    this.portalData = { roomId, name, image };
  };

  onUserDoubleLogin = () => {
    // globalStore.dubleLoginLogut()
  };

  onOpenPetanqueEventPage = () => {
    this.onOpenPortalToSpace(
      829694783,
      "Tamada's Virtual Concert at Petanque Digital Club",
      'https://fv-media.storage.googleapis.com/room_preview_image/P03.png',
    );
  };

  onObjectDeselected = () => {
    this.setIsActiveControllers(false);
    if (unityfooterStore.showModelController) {
      unityfooterStore.setShowModelController(false);
    }
    sendMessageStore.deselectObject();
  };

  onObjectSelected = (
    publicId: number,
    type: number,
    coordinate: string,
    url: string,
    isSelected: number,
  ) => {
    this.setControllersProps({
      publicId,
      type,
      coordinate,
      url,
      isSelected,
    });
    sendMessageStore.setSelectedModelById(publicId);
    roomModelControllerStore.setInitControllers({
      publicId,
      type,
      coordinate: JSON.parse(coordinate),
      url,
    });
    this.setLocked(!!isSelected);
    this.setIsActiveControllers(true);
  };

  onFreezeStateForUserChanged = (id: any, state: any) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === Number(id)) {
        participantsStore.user.freezedValue = Boolean(state);
        user.freezedValue = Boolean(state);
      }
      return user;
    });
    if (id === cacheService.getMyId) {
      if (state) {
        globalStore.setNotifications(true, 'frozen');
        agoraStore.videoEnabled && scenetemplateStore.videoToggle();
        agoraStore.micEnabled && scenetemplateStore.audioToggle();
      } else {
        globalStore.setNotifications(true, 'unfrozen');
      }
    }
  };

  onReceiveBuildingData = realEstateStore.onReceiveBuildingData;

  onReceiveFloorData = realEstateStore.onReceiveFloorData;

  onReceiveRoomData = realEstateStore.onReceiveRoomData;

  onConstructLoadingPhase = realEstateStore.onConstructLoadingPhase;

  onHoverExit = realEstateStore.onHoverExit;

  onReceiveConstructRoomData = realEstateStore.onReceiveConstructRoomData;

  onMicStateForUserChanged = (id: number, state: number) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === id) {
        participantsStore.user.talkingValue = state;
        user.talkingValue = state;
      }
      return user;
    });

    if (id === cacheService.getMyId) {
      return scenetemplateStore.audioToggle(state);
    }
  };

  onRemoveUserAudioState = (id: number) => {
    this.roomUsersState = this.roomUsersState.filter(
      (user) => user.publicId !== id,
    );
  };

  onSpeakingStateForUserChanged = (...data: any) => {
    console.log(data);
  };

  setIsActiveControllers = (bool: boolean) => {
    this.isActiveControllers = bool;
  };

  setControllersProps = (data: any) => {
    this.controllersProps = data;
  };

  sendRoomData = () => {
    this.instance.SendMessage(
      'ReactManager',
      'SetServerApi',
      requestOptions.baseURL,
    );
    this.instance.SendMessage(
      'ReactManager',
      'Login',
      transformUserData(globalStore.userData),
    );
    this.setLoadingProgression(1);
  };

  onUnityReady = () => {
    this.sendRoomData();
    this.instance.SendMessage(
      this.managerOptions.manager,
      this.managerOptions.method,
      this.roomId,
    );
  };

  onAddUserAudioState = (
    username: string,
    publicId: number,
    talkingValue: number,
    micValue: number,
    freezedValue: boolean,
    haveMic: number,
    isGuest: number,
    privateCallState: number,
    isFastBankUser: number,
    micPermissions: number,
    micPermissionGranted: number,
    email: string,
    avatarImageUrl: string,
    withAvatar: number,
  ) => {
    const data: UnityLayout.RoomUsersState = {
      username,
      publicId,
      email,
      talkingValue,
      micValue,
      freezedValue: unityProviderStore.roomData.freezeUsers?.some(
        (freezeUser: any) => freezeUser.id == publicId,
      ),
      haveMic,
      isGuest: Boolean(isGuest),
      privateCallState,
      isFastBankUser,
      micPermissions,
      micPermissionGranted,
      isCreator: this.userIsCreator(publicId),
      isAdmin: participantsStore.userIsAdmin(publicId),
      avatarImageUrl: avatarImageUrl || '',
      withAvatar: Boolean(withAvatar),
    };
    this.roomUsersState = [...this.roomUsersState, data];
  };

  userIsCreator = (id = 0) => {
    const res = this.roomData?.creator?.id == id;
    return res;
  };

  onSceneFullyLoaded = (...data: any) => {
    this.setLoadingProgression(1);
    if (isMobile) {
      // unityheaderStore.setTouchControlState(true)
      this.instance.SendMessage(
        'InputJsEventsHandle',
        'SetIsTouchSupported',
        'True',
      );
    }
  };

  onReserveTable = (id: any) => {
    if (globalStore.userIsGuest()) {
      const { pathname } = window.location;
      globalStore.setGuestPopupState(true, pathname);
    } else {
      reserveTablePopupsStore.onReserve(id);
    }
  };

  hasUserOnFreeze = (id = cacheService.getMyId) =>
    this.roomUsersState.filter((user) => user.publicId === id)[0]?.freezedValue;

  muteAllUsers = () => {
    sendMessageStore.sendMessage(
      'ReactManager',
      'SetOtherUserMicrophoneState',
      JSON.stringify({
        id: 0,
        mic: false,
      }),
    );
  };

  onRoomMicrophoneUseAbilityChanged = () => {
    this.micPermission = !this.micPermission;
  };

  micActiveHandler = () => {
    sendMessageStore.sendMessage(
      'ReactManager',
      'GrantMicUseAbilityToOtherUsers',
      JSON.stringify({
        micPermissionGranted: !this.micPermission,
        userIds: null,
      }),
    );
    this.onRoomMicrophoneUseAbilityChanged();
  };

  handleFreeze = async (user: UnityLayout.RoomUsersState, roomId: number) => {
    const event = user.freezedValue
      ? MICROPHONE_STATUS[0]
      : MICROPHONE_STATUS[2];
    try {
      if (event === 'FREEZE') {
        await apiServiceV2.freezeUser({
          userIds: [user.publicId],
        });
        sendMessageStore.sendMessage(
          'ReactManager',
          'ExecuteCommand',
          JSON.stringify({
            command: '11',
            data: {
              userId: user.publicId,
              state: true,
            },
          }),
        );
      } else {
        await apiServiceV2.unfreezeUser(user.publicId);
        sendMessageStore.sendMessage(
          'ReactManager',
          'ExecuteCommand',
          JSON.stringify({
            command: '11',
            data: {
              userId: user.publicId,
              state: false,
            },
          }),
        );
      }
      this.roomUsersState = this.roomUsersState.map((item) => {
        if (item.publicId === user.publicId) {
          participantsStore.user.freezedValue = !user.freezedValue;
          item.freezedValue = !user.freezedValue;
        }
        return item;
      });
    } catch (e: any) {
      console.warn('ERROR: ', e.message);
    }
  };

  makeAdminHandler = async (user: UnityLayout.RoomUsersState) => {
    try {
      await apiServiceV2.makeUserAdmin({
        userIds: [user.publicId],
      });
      sendMessageStore.sendMessage(
        'ReactManager',
        'ExecuteCommand',
        JSON.stringify({
          command: '10',
          data: {
            admins: [
              {
                public_id: Number(user.publicId),
                username: user.username,
              },
            ],
            room_public_id: Number(unityProviderStore.roomData.id),
          },
        }),
      );
      sendMessageStore.sendMessage(
        'ReactManager',
        'ExecuteCommand',
        JSON.stringify({
          command: '10',
          data: {
            admins: [
              {
                public_id: Number(user.publicId),
                username: user.username,
              },
            ],
            userId: Number(user.publicId),
            email: user?.email,
            username: user.username,
            roomId: Number(unityProviderStore.roomData.id),
            IsAdmin: true,
          },
        }),
      );
    } catch (e: any) {
      console.warn('ERROR: ', e.message);
    }
  };

  handleBlockUser = async (
    user: UnityLayout.RoomUsersState | undefined,
    roomId: string | undefined,
  ) => {
    try {
      await apiServiceV2.blockUser(
        {
          userIds: [user?.publicId as number],
        },
        roomId,
      );
      sendMessageStore.sendMessage(
        'ReactManager',
        'ExecuteCommand',
        JSON.stringify({
          command: '9',
          data: {
            room_public_id: unityProviderStore.roomData.id,
            user_public_id: user?.publicId,
          },
        }),
      );
      this.blockedUsers = [
        ...this.blockedUsers,
        { id: user?.publicId, username: user?.username },
      ];
    } catch (e: any) {
      console.warn('ERROR: ', e.message);
    }
  };

  onBlockUser = (userId: number, roomId: number) => {
    if (userId === Number(cacheService.get('Id'))) {
      globalStore.setNotifications(true, 'block');
      this.setIsLoaded(false);
      this.roomData = {};
      sendMessageStore.sendMessage('ReactManager', 'UnloadSpace', `${roomId}`);
      globalStore.navigation('/dashboard/cerebrum');
    }
  };

  onUserMicAvailable = (id: number, state: number) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === id) {
        participantsStore.user.micIsExist = Boolean(state);
        user.micIsExist = Boolean(state);
      }
      return user;
    });
  };

  clearRoomUsersState = () => {
    this.roomUsersState = [];
  };

  removePortalData = () => {
    this.portalData = null;
    sendMessageStore.unLockKeyboardInput();
  };

  onPortalTo = async (leave: any) => {
    await leave();
    this.roomData.previewImage = this.portalData?.image;
    this.roomData.name = this.portalData?.name;
    this.setIsLoaded(false);
    this.setLoadingProgression(0);
    sendMessageStore.sendMessage(
      'ReactManager',
      'UnloadSpace',
      `${this.roomId}`,
    );
    this.setRoomDataStatus(false);
    this.clearRoomUsersState();
    globalStore.navigation(`/room/${this.portalData?.roomId}`);
    this.removePortalData();
  };

  onReturnNearestTransform = (data: any) => {
    const position = JSON.parse(data);
    this.avatarPosition = JSON.stringify(position);
  };

  OnPhotonConnectionError = (...data: any) => {
    console.log(data);
  };

  userInCall = (id: number) => {
    const inCall =
      this.roomUsersState.filter((user) => user.publicId === id)[0]
        .privateCallState !== 0;
    if (inCall) {
      globalStore.setToasts(true, 'inprivatcall');
    }
    return inCall;
  };

  setHooryToken = (token: string) => {
    if (this.hooryToken !== token) this.hooryToken = token;
  };

  setCopiaData = (copiaData: any) => {
    this.copiaData = copiaData;
  };

  setHotelRooms = (hotelRooms: any) => {
    this.hotelRooms = hotelRooms;
  };

  setRoomData = (roomData: any) => {
    if (Object.keys(roomData).length) {
      participantsStore.setAdminUsers(roomData.admins);
      this.blockedUsers = roomData.blockedUsers;
      this.setHooryToken(roomData.hooryWebsiteToken);
      this.setRoomDataStatus(true);
      return (this.roomData = {
        ...this.roomData,
        ...roomData,
      });
    }
    this.setRoomDataStatus(false);
    return (this.roomData = {});
  };

  hasEventRoom = (eventData: any): boolean => !!eventData.length;

  onOpenUserMenu = (...data: any) => {
    const playerData: TPlayerUserData = JSON.parse(data);
    const inCall = this.userInCall(playerData.public_id);

    if (inCall) return null;
    privateCallHandler({
      public_id: playerData.public_id,
      username: playerData.username,
    });
  };

  handleDownload = () => {
    fetch(this.controllersProps.url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/*',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `file.${this.controllersProps.url.split('.').pop()}`,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode!.removeChild(link);
      });
  };

  onInviteToAgoraChanel = (data: string) => {
    const callData: TCallData = JSON.parse(data);
    if (cacheService.getMyId === callData.target_user) {
      const sender = this.roomUsersState.filter(
        (user) => user.publicId === callData.sender_user,
      )[0];
      inviteHandler(callData, sender);
    }
  };

  onPrivateCallStateChanged = (id: number, state: CallStatus) => {
    this.roomUsersState = this.roomUsersState.map((user) => {
      if (user.publicId === id) {
        participantsStore.user.privateCallState = state;
        user.privateCallState = state;
      }
      return user;
    });
    responseCallUser(id, state);
  };

  onRemovedFromCall = () => {
    leavePrivateCall();
  };

  handleLock = () => {
    sendMessageStore.sendMessage('ReactManager', 'ToggleLockObject');
    this.setControllersProps({
      ...this.controllersProps,
      isSelected: !this.locked,
    });
    this.setLocked(!this.locked);
  };

  handleUnBlockUser = async (uid: any, roomId: string | undefined) => {
    try {
      await apiServiceV2.unBlockUser(roomId, uid);
      sendMessageStore.sendMessage(
        'ReactManager',
        'ExecuteCommand',
        JSON.stringify({
          command: '9',
          data: {
            room_public_id: roomId,
            user_public_id: uid,
          },
        }),
      );
      this.blockedUsers = this.blockedUsers.filter(
        (user: any) => user.id !== uid,
      );
    } catch (error) {
      console.log(error);
    }
  };

  getBuildData = async (version: string) => {
    const { data }: any = await apiServiceV2.getBuildUrls(version);
    this.loader = data.loader;
    this.build = {
      dataUrl: data.data,
      frameworkUrl: data.framework,
      codeUrl: data.wasm,
    };
  };

  clearBuilds = () => {
    this.loader = '';
    this.build = {};
  };

  getApartmentData = async (
    id: string | undefined,
    type: keyReactManager = 'apartments',
    hotelRoomId?: string | undefined,
  ) => {
    await this.getBuildData(build);

    if (hotelRoomId !== undefined) {
      const res: any = await apiServiceDepartments.getHotelRoom(
        `${id}`,
        hotelRoomId,
      );
      if (res.error) {
        globalStore.setNotifications(true, 'room_error');
      } else {
        const result = res.data?.result;
        if (result) {
          this.setCopiaData(result);
          cacheService.set('roomId', id);
          this.setRoomData(result);
        }
      }
    } else {
      const res: any = await apiServiceV2.getApartmentByID(`${type}/${id}`);
      if (res.error) {
        globalStore.setNotifications(true, 'room_error');
      } else {
        const result = res.data?.result;
        if (result) {
          this.setCopiaData(result);
          cacheService.set('roomId', id);
          this.setRoomData(result);
          if (type === 'hotels') {
            this.setHotelRooms(result?.rooms || []);
          }
        }
      }
    }
  };

  roomDataErrorHandler = (res: any, pathname: any) => {
    if (
      res.message === 'Authentication failed.' ||
      res.message === 'Token is not found or expired.'
    ) {
      cacheService.clear();
      globalStore.setIsLogin(false);
      globalStore.navigation('/');
      return globalStore.setGuestPopupState(true, pathname);
    }
    globalStore.setNotifications(true, 'room_error');
  };

  checkEventRoom = (data: any) => {
    const eventData = data.eventData;
    return {
      isEventData:
        eventData.length &&
        eventData[0].eventType === 1 &&
        checkEventsDates(
          eventData[0]?.eventStartDate,
          eventData[0]?.eventEndDate,
        ),
    };
  };

  checkMeetingRoom = (id: string) => {
    const meetingRooms: string[] = ['820', '2327', '3038'];
    let isMeetingRoom = false;

    if (meetingRooms.includes(id)) {
      isMeetingRoom = true;
    }
    return {
      isMeetingRoom,
      isGuest: globalStore?.userIsGuest(),
    };
  };

  checkUserState = async (
    id = '',
    navigateTo: Function,
    runInMobile: boolean | undefined,
    avatarMod: string | null = '',
  ) => {
    const { isMeetingRoom, isGuest } = this.checkMeetingRoom(id);

    if (isMeetingRoom && isGuest) {
      globalStore.setGuestPopupState(true, window.location.pathname);
      return globalStore?.navigation('/');
    }
    const res: any = await globalStore.getUserData();
    if (res.error) {
      await globalStore.createGuestUser(navigateTo);
    } else {
      await this.getRoomData(id, runInMobile, avatarMod);
    }
  };

  checkCopiaUserState = async (
    id: string | undefined,
    navigateTo: Function,
    type: keyReactManager = 'apartments',
    hotelRoomId?: string | undefined,
  ) => {
    const res: any = await globalStore.getUserData();
    if (res.error) {
      await globalStore.createGuestUser(navigateTo);
    } else {
      await this.getApartmentData(id, type, hotelRoomId);
    }
  };

  creatorOrAdmin = (id: any, admins: any) => {
    return isCreator(id) || isAdmin(admins);
  };

  checkEventActuality = (data: any) => {
    const { eventData, creator, admins, visitors } = data;

    return (
      this.hasEventRoom(eventData) &&
      eventData[0].eventType === 2 &&
      !checkEventIsEnded(eventData[0]?.eventEndDate) &&
      (!isVisitor(visitors, globalStore.userData.id) ||
        (isVisitor(visitors, globalStore.userData.id) &&
          !checkEventsDates(
            eventData[0]?.eventStartDate,
            eventData[0]?.eventEndDate,
          ))) &&
      !this.creatorOrAdmin(creator.id, admins)
    );
  };

  setRoomInfo = async (data: any, id: any, isGuest: any, pathname: any) => {
    const { eventData, visitors } = data;

    if (this.checkEventActuality(data)) {
      if (isGuest) {
        globalStore.navigation('/');
        return globalStore.setGuestPopupState(true, pathname);
      } else {
        return ticketupload.uploadTicketPopup(eventData[0], +id, visitors);
      }
    } else {
      this.setRoomData(data);
    }
  };

  getRoomData = async (
    id = '',
    runInMobile: boolean | undefined,
    avatarMod: string | null = '',
  ) => {
    const { pathname } = window.location;
    try {
      const myId = cacheService.getMyId;
      this.roomId = id;
      const res: any = await apiServiceV2.getRoomByID(id);

      if (res.error) {
        return this.roomDataErrorHandler(res, pathname);
      } else {
        roomModelControllerStore.setRoomObjects(res.data?.models || []);
        const { isEventData } = this.checkEventRoom(res.data);

        if (isEventData && globalStore.userIsGuest()) {
          globalStore.setGuestPopupState(true, window.location.pathname);
          return globalStore.navigation('/');
        }

        if (
          !res.data.isShowAvatar &&
          !cardsblockStore.selectedRoomId &&
          !avatarMod &&
          !isMobile
        ) {
          cardsblockStore.setShowSwitcher(true);
          cardsblockStore.setSelectedRoomId(this.roomId);
          return;
        }

        const blockedUser = res.data.blockedUsers.filter(
          (user: any) => user.id == myId,
        );

        if (blockedUser.length) {
          this.setRoomDataStatus(false);
          return globalStore.setNotifications(true, 'start_block');
        }

        const kickedUser = res.data.kickedUsers.filter(
          (user: any) => user.id == myId,
        );

        if (kickedUser.length) {
          this.setRoomDataStatus(false);
          const { time, dateString } = getKickTimeEnd(
            kickedUser[0].remove_kick_date,
          );

          if (time.length) {
            return globalStore.setNotifications(
              true,
              'start_kicked',
              'You have been kicked for',
              dateString,
            );
          }
        }

        cacheService.set('roomId', id);

        if (isMobile && runInMobile === undefined) {
          return cardsblockStore.setOpenInAppData(res.data);
        }

        if (avatarMod) {
          this.openZoomChat(true);
          cardsblockStore.setSelectedOption(avatarMod);
          cardsblockStore.setSelectedRoomId(this.roomId);
          this.setRoomData(res.data);
        }

        await this.setRoomInfo(
          res.data,
          id,
          globalStore.userIsGuest(),
          pathname,
        );
        await this.getBuildData(build);
      }
    } catch (e: any) {
      this.checkMeetingRoom(id);
      console.log('ERROR: ', e.message);
      return globalStore.setGuestPopupState(true, pathname);
    }
  };

  onGetBundle = () => {
    sendMessageStore.sendMessage(
      'ReactManager',
      'LoadScene',
      JSON.stringify(this.roomData),
    );
  };

  onGetPlatform = () => {
    sendMessageStore.sendMessage(
      'ReactManager',
      'SetPlatform',
      isMobile ? 'Mobile' : 'Desktop',
    );
  };

  onGetEnviro = () => {
    sendMessageStore.sendMessage('ReactManager', 'SetIsEnviro', 'false');
  };

  setUpdateTexture = (func: Function) => {
    this.updateTexture = func;
  };

  onOpenUrl = (url: string, isIframe = 1) => {
    if (isIframe === 1) this.openUrl = url;
    else if (url !== '') window.open(url);
  };

  onOpenTerminal = () => {
    this.setShowFaq(true);
  };

  setShowFaq = (state: boolean) => {
    this.showFaq = state;
  };

  setNftData = (data: NftDataType) => {
    this.nftData = data;
  };

  setRoomDataStatus = (state: boolean) => {
    this.roomDataStatus = state;
  };

  openZoomChat = (bool: boolean) => {
    this.conferencePopup = bool;
  };

  clearUnityBuilds = () => {
    const scripts = document.body.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (
        !!scripts[i].getAttribute('src') &&
        ((scripts[i].getAttribute('src') as string).includes('loader') ||
          (scripts[i].getAttribute('src') as string).includes('framework'))
      ) {
        scripts[i].remove();
        --i;
      }
    }
    // this.setRoomDataStatus(false);
    this.clearBuilds();
  };

  removeState = () => {
    this.hotelRooms = [];
    this.roomData = {};
    this.showBookingPopup = false;
    this.conferencePopup = false;
  };
}

export const unityProviderStore = new UnityProviderStore();
